import { provide, inject, watch, ref, computed } from 'vue'
import { useRoute } from 'vue-router/composables'
import { OCR_INJECTION_KEY, OCR_HELPER_INJECTION_KEY } from '../../../tokens/index'

//注入ocr识别路由方法
export function useOcrProvide() {
  const route = useRoute()

  const ocrAdd = ref({})
  provide(OCR_HELPER_INJECTION_KEY, ocrAdd)
  watch(route, () => {
    ocrAdd.value = {}
  })
  provide(OCR_INJECTION_KEY, (code, fn) => {
    ocrAdd.value = {
      [route.name]: {
        code,
        fn,
      },
    }
  })
}
//在ocr助手组件中接受ocr添加方法
export function useOcrHelperInject() {
  const route = useRoute()
  const ocrAdd = inject(OCR_HELPER_INJECTION_KEY)
  const addMethod = computed(() => ocrAdd.value[route.name])
  return addMethod
}
//在页面中接受设置ocr设置方法
export function useOcrInject() {
  const ocrSetMethod = inject(OCR_INJECTION_KEY)
  return ocrSetMethod
}
